import React, { AnchorHTMLAttributes, ReactNode, useEffect, useState } from 'react';
const ROUTE_EVENT = 'pines-route-change';
function scrollToHash(hash: string, attempt = 0) {
  window.requestAnimationFrame(() => {
    const target = document.getElementById(hash);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }
    // The destination page may not have mounted yet — retry briefly.
    if (attempt < 20) scrollToHash(hash, attempt + 1);
  });
}
export function navigate(to: string) {
  const [path, hash] = to.split('#');
  const targetPath = path || '/';
  if (window.location.pathname === targetPath) {
    if (hash) {
      scrollToHash(hash);
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    return;
  }
  window.history.pushState({}, '', to);
  window.dispatchEvent(new Event(ROUTE_EVENT));
  if (hash) {
    scrollToHash(hash);
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

/** Swap the current URL without adding a history entry. */
export function replaceRoute(to: string) {
  window.history.replaceState({}, '', to);
  window.dispatchEvent(new Event(ROUTE_EVENT));
}
export function useCurrentRoute() {
  const [path, setPath] = useState(() => window.location.pathname || '/');
  useEffect(() => {
    const handleChange = () => setPath(window.location.pathname || '/');
    window.addEventListener('popstate', handleChange);
    window.addEventListener(ROUTE_EVENT, handleChange);
    return () => {
      window.removeEventListener('popstate', handleChange);
      window.removeEventListener(ROUTE_EVENT, handleChange);
    };
  }, []);
  return path;
}
interface RouteLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  children: ReactNode;
}
export function RouteLink({
  to,
  children,
  onClick,
  ...props
}: RouteLinkProps) {
  return <a {...props} href={to} onClick={event => {
    onClick?.(event);
    if (event.defaultPrevented || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    navigate(to);
  }} data-id="element-692" data-mp="2awnbn30zg37e">
      {children}
    </a>;
}